import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { GlobalStyles, Layout, Content, Sidebar, SubHeader } from "./styles";
import GoBack from "../../GoBack";
import Header from "./components/Header";
import Actions from "../components/Actions";
import SearchBar from "./components/SearchBar";
import Filters from "../components/Filters";
import Menu from "./components/Menu";
import Title from "../components/Title";
import Breadcrumb from "../components/Breadcrumb";
import Logo from "../components/Logo";
import { useActions } from "../../../provider/ActionsProvider";
import { useLayout } from "../../../provider/LayoutProvider";
import { useEffect, useState } from "react";
import { Center } from "../../StyledComponents";
import services from "../../../services";
import { UserDto } from "../../../types/user.dto";
import Dropdown from "../../Dropdown";

interface ComponentProps {}

const Component = ({}: ComponentProps) => {
  const { layout } = useLayout();
  const [userInfo, setUserInfo] = useState<UserDto>();

  useEffect(() => {
    setUserInfo(services.user.getUserInformation());
  }, []);

  return (
    <>
      <GlobalStyles />

      <Layout
        className={layout.sidebarOpened ? "sidebar-opened" : "sidebar-closed"}
      >
        <Header>
          <Dropdown userInfo={userInfo} />
        </Header>

        {layout.showSubHeader && (
          <SubHeader>
            <Center style={{ justifyContent: "flex-start" }}>
              {layout.showBackButton && <GoBack />}

              <div style={{ flexShrink: 0 }}>
                <Title />
                <Breadcrumb />
              </div>
            </Center>
          </SubHeader>
        )}

        <Content fullFillContent={layout.fullFillContent}>
          {(layout.showSearchBar || layout.showFilters) && (
            <Center style={{ justifyContent: "flex-end" }}>
              {layout.showSearchBar && <SearchBar />}
              {layout.showFilters && <Filters />}
            </Center>
          )}

          <div style={{ height: 20 }} />
          <Outlet />
        </Content>

        <Sidebar>
          <Logo />
          <Menu />
        </Sidebar>

        <ToastContainer />
      </Layout>
    </>
  );
};

export default Component;
